import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.whiteish,
  borderColor: colors.overcast,
  linkColor: colors.rust
};
export default jumplink;